import { Auth, API } from "aws-amplify";
import {
  ADD_ORDER_TO_BASKET,
  ADD_ORDER_TO_BASKET_FAILURE,
  ADD_ORDER_TO_BASKET_SUCCESS,
  BELL_ICON_RESET,
  CONFIRM_ORDER,
  CONFIRM_ORDER_FAILURE,
  CONFIRM_ORDER_SUCCESS,
  GET_ORDER_FROM_BASKET,
  GET_ORDER_FROM_BASKET_FAILURE,
  GET_ORDER_FROM_BASKET_SUCCESS,
  GET_PAST_ORDERS,
  GET_PAST_ORDERS_FAILURE,
  GET_PAST_ORDERS_SUCCESS,
  REMOVE_ORDER,
  REMOVE_ORDER_FAILURE,
  REMOVE_ORDER_SUCCESS,
} from "../constant";

export const addOrderToBasket = () => {
  return {
    type: ADD_ORDER_TO_BASKET,
  };
};

const addOrderToBasketSuccess = (success, message, data) => {
  return {
    type: ADD_ORDER_TO_BASKET_SUCCESS,
    payload: { success, message, data },
  };
};
const addOrderToBasketFailure = (error) => {
  return {
    type: ADD_ORDER_TO_BASKET_FAILURE,
    payload: { error },
  };
};

export const addOrders = (data) => {
  return async (dispatch) => {
    dispatch(addOrderToBasket());
    API.post("AdminQueries", "/api/v1/addordertobasket", {
      body: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        if (res.success) {
          dispatch(addOrderToBasketSuccess(res.success, res.message, data));
        }
      })
      .catch((err) => {
        dispatch(
          addOrderToBasketFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err?.message
          )
        );
      });
  };
};
export const getOrdersFromBasket = () => {
  return {
    type: GET_ORDER_FROM_BASKET,
  };
};

const getOrderFromBasketSuccess = (success, orders) => {
  return {
    type: GET_ORDER_FROM_BASKET_SUCCESS,
    payload: { success, orders },
  };
};

const getOrderFromBasketFailure = (error) => {
  return {
    type: GET_ORDER_FROM_BASKET_FAILURE,
    payload: { error },
  };
};

export const getOrders = (data) => {
  return async (dispatch) => {
    dispatch(getOrdersFromBasket());
    API.get("AdminQueries", "/api/v1/getordersfrombasket", {
      queryStringParameters: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(getOrderFromBasketSuccess(res.success, res.message.rows));
      })
      .catch((err) => {
        dispatch(getOrderFromBasketFailure(err));
      });
  };
};

export const confirmOrderPost = () => {
  return {
    type: CONFIRM_ORDER,
  };
};

const confirmOrderSuccess = (success, message, data) => {
  return {
    type: CONFIRM_ORDER_SUCCESS,
    payload: { success, message, data },
  };
};

const confirmOrderFailure = (error) => {
  return {
    type: CONFIRM_ORDER_FAILURE,
    payload: { error },
  };
};

export const confirmOrders = (data) => {
  return async (dispatch) => {
    dispatch(confirmOrderPost());
    API.post("AdminQueries", "/api/v1/confirmorder", {
      body: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(confirmOrderSuccess(res.success, res.message, data));
      })
      .catch((err) => {
        dispatch(confirmOrderFailure(err));
      });
  };
};

export const fetchGetPastOrders = () => {
  return {
    type: GET_PAST_ORDERS,
  };
};

const getPastOrdersSuccess = (success, orders) => {
  return {
    type: GET_PAST_ORDERS_SUCCESS,
    payload: { success, orders },
  };
};

const getPastOrdersFailure = (error) => {
  return {
    type: GET_PAST_ORDERS_FAILURE,
    payload: { error },
  };
};

export const getPastOrders = (data) => {
  return async (dispatch) => {
    dispatch(fetchGetPastOrders());
    API.get("AdminQueries", "/api/v1/getpastorders", {
      queryStringParameters: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(getPastOrdersSuccess(res.success, res.message.rows));
      })
      .catch((err) => {
        dispatch(
          getPastOrdersFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err?.message
          )
        );
      });
  };
};

export const removeOrderPost = () => {
  return {
    type: REMOVE_ORDER,
  };
};

const removeOrderSuccess = (success, message, data, id) => {
  return {
    type: REMOVE_ORDER_SUCCESS,
    payload: { success, message, data, id },
  };
};

const removeOrderFailure = (error) => {
  return {
    type: REMOVE_ORDER_FAILURE,
    payload: { error },
  };
};

export const removeOrders = (data, id) => {
  return async (dispatch) => {
    dispatch(removeOrderPost());
    API.del("AdminQueries", "/api/v1/removeorder", {
      queryStringParameters: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(removeOrderSuccess(res.success, res.message, data, id));
      })
      .catch((err) => {
        dispatch(
          removeOrderFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err?.message
          )
        );
      });
  };
};

export const bellIconReset = () => {
  let val = 0;
  return {
    type: BELL_ICON_RESET,
    payload: { val },
  };
};
